<button red-button [attr.background]="background" [attr.redType]="type" [attr.redShape]="shape" [disabled]="disabled"
  [attr.redSize]="size" [attr.redPadding]="padding">
  <ng-content></ng-content>
</button>